import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { getUOMData } from '../../store/weightSlice';
import { MwButton, MwSpinner } from '../ui';
import { AiOutlineDelete } from "react-icons/ai";
import { MdOutlineEdit } from "react-icons/md";
import { CiViewList } from "react-icons/ci";
import { IoAddCircleOutline } from "react-icons/io5";
import { useDelete, useTenant } from '../../hooks';
 import { toast,ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DeleteConfirmationModal from '../OsRequisition/RequisitionComponents/DeleteConfirmationModal';
import ActiveIndicator from '../common/ActiveIndicator';
import ActionsDropdown from './../common/ActionsDropdown';
import { useTranslation } from 'react-i18next';
 
 

const OsViewWeights = ({ idSelected, setIdSelected, setMode }) => {
    const { tenantId, loading: tenantLoading, error: tenantError } = useTenant();
    const navigate = useNavigate();
    const { tenant } = useParams();
    const dispatch = useDispatch();
    const { deleteItem, loading: deleteLoading } = useDelete();
  const { t, i18n } = useTranslation('global');
    const isRTL = i18n.dir() === 'rtl';
    const { uomData, loading, error } = useSelector((state) => state.weight);
    const units = uomData ? uomData : [];
  
    // حالة النافذة لتأكيد الحذف
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [selectedUnitId, setSelectedUnitId] = useState(null);
  
    useEffect(() => {
      if (tenantId) {
        dispatch(getUOMData(tenantId));
      }
    }, [dispatch, tenantId]);
  
    const handleEdit = (id) => {
      setIdSelected(id);
      setMode('Edit');
    };
  
    const handleDelete = (id) => {
      setSelectedUnitId(id);
      setDeleteModalOpen(true);
    };
  
    const handleConfirmDelete = () => {
      if (selectedUnitId && tenantId) {
        deleteItem(`${process.env.REACT_APP_INV_API_SERVER_BASE_URL}/inventory/uom/${selectedUnitId}`)
          .then(() => {
            toast.success("تم الحذف بنجاح!", {
              style: {
                backgroundColor: '#e5e7eb',
                color: '#374151',
                padding: '1rem',
                borderRadius: '0.5rem',
                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)'
              }
            });
            setDeleteModalOpen(false);
            setSelectedUnitId(null);
            dispatch(getUOMData(tenantId));
          })
          .catch((error) => {
            toast.error("حدث خطأ أثناء محاولة الحذف!", {
              style: {
                backgroundColor: '#e5e7eb',
                color: '#374151',
                padding: '1rem',
                borderRadius: '0.5rem',
                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)'
              }
            });
            console.error('Error deleting unit:', error);
          });
      }
    };
  
    const handleView = (id) => {
      setIdSelected(id);
      setMode('Details');
    };
  
    const AddUnit = () => {
      setMode('Add');
    };
  
    if (tenantLoading || loading) {
      return  <div className="h-32 flex justify-center items-center">
      <MwSpinner />
    </div>
    }
  
    if (tenantError || error) {
      return (
        <div className="bg-red-50 p-4 rounded-lg">
          <p className="text-red-600">
            حدث خطأ أثناء تحميل البيانات: {tenantError?.message || error?.message || 'خطأ غير معروف'}
          </p>
        </div>
      );
    }
  
    if (units.length === 0) {
      return (
        <div className="bg-gray-50 p-6 rounded-lg text-center">
          <p className="text-gray-600 mb-4">لا توجد وحدات متاحة</p>
          <div>
            <MwButton inGroup={true} type="saveBtn" onClick={AddUnit}>
              <IoAddCircleOutline />
              <span> {t('Warehouse_settings.Add new Unit')}    </span>
            </MwButton>
          </div>
        </div>
      );
    }
  
    return (
      <div className="min-w-[600px] text-xs   relative bg-gray-50 rounded-2xl">
        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={true}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
          style={{ top: '100px' }} />
       
      
  
        {/* Header */}
        <div className="grid grid-cols-12 gap-3 px-4 mt-2 bg-slate-200 font-bold text-slate-500 text-sm rounded-t-2xl justify-between items-center border-t py-4 hover:bg-indigo-50 hover:font-bold">
          <div className="col-span-1  ">#</div>
          <div className="col-span-4">{t('Warehouse_settings.Unit Name')}</div>
          <div className="col-span-4">{t('Warehouse_settings.Label')}</div>
          <div className="col-span-2 text-center"> {t('Warehouse_settings.Creation Date')}  </div>
          <div className="col-span-1 text-center"></div>
        </div>
  
        {/* List Rows */}
        <div className="h-[35vh] overflow-y-auto custom-scrollbar">
          {units.map((unit, index) => (
            <div
              key={unit.id}
              className="grid grid-cols-12 gap-3 px-4 py-2 border-t cursor-pointer items-center hover:bg-indigo-50"
              onClick={() => handleView(unit.id)}
            >
              <div className="col-span-1 text-slate-600">{index + 1}</div>
              <div className="col-span-4 text-slate-600">{unit?.name || 'اسم غير متوفر'}</div>
              <div className="col-span-4 text-slate-600">{unit?.uom_master?.name || 'تسمية غير متوفرة'}</div>
              <div className="col-span-2 text-center text-slate-600">
                {unit?.created_at ? new Date(unit.created_at).toLocaleDateString("en-EG") : '-'}
              </div>
              <div
                className="col-span-1 flex items-center justify-end gap-2"
                onClick={(e) => e.stopPropagation()}
              >
                <ActiveIndicator active={unit.is_active} />
                <ActionsDropdown
                 isRTL={isRTL}
                  onView={(id) => handleView(id)}
                  onEdit={(id) => handleEdit(id)}
                  onDelete={(id, e) => {
                    e.stopPropagation();
                    handleDelete(id);
                  }}
                  itemId={unit.id}
                  viewText= {t('Warehouse_settings.View')}
                  editText= {t('Warehouse_settings.Edit')}
                  deleteText= {t('Warehouse_settings.Delete')}
                />
              </div>
            </div>
          ))}
        </div>
  
        <DeleteConfirmationModal
          isOpen={deleteModalOpen}
          onClose={() => setDeleteModalOpen(false)}
          onConfirm={handleConfirmDelete}
          loading={deleteLoading}
        />
      </div>
    );
  };
  
  export default OsViewWeights;